import React from 'react'
import LoadingSpinner from 'redesign/components/atoms/LoadingSpinner'
import { DrawerHeaderWrapper } from 'redesign/components/molecules/drawer-header-wrapper'
import SideMenuNestedHeader from 'redesign/components/organisms/headers/side-menu-nested-header'
import useTaskDetailsPage from 'redesign/pages/task-details/use-task-details-page'
import TimelineActionButtonProvider from 'redesign/services/timeline-action-button/timeline-action-button-provider'
import { SIDE_MENU_ROOT_ID } from '../../SideMenu/constants'
import type { SubpageDetailProps } from '../types'
import TaskDetailContent from './task-detail-content'

const TaskDetail: React.FC<SubpageDetailProps> = ({
  onClose,
  isDrawer,
  onGoBack,
  isOffice,
  selectedTaskUuid,
  refetchTask,
  titleKey,
}) => {
  const { task, loading, refetch } = useTaskDetailsPage({ taskUuid: selectedTaskUuid })
  const isLoading = loading || !task

  if (isLoading) {
    return (
      <DrawerHeaderWrapper
        header={<SideMenuNestedHeader onClose={onClose} isDrawer={isDrawer} titleKey={titleKey} onGoBack={onGoBack} />}
      >
        <LoadingSpinner />
      </DrawerHeaderWrapper>
    )
  }

  return (
    <TimelineActionButtonProvider rootId={SIDE_MENU_ROOT_ID}>
      <TaskDetailContent
        isDrawer={isDrawer}
        onClose={onClose}
        onGoBack={onGoBack}
        refetch={refetch}
        task={task}
        isOffice={isOffice}
        refetchTask={refetchTask}
        selectedTaskUuid={selectedTaskUuid}
        titleKey={titleKey}
      />
    </TimelineActionButtonProvider>
  )
}

export default TaskDetail
